var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cards-industries" }, [
    _c(
      "div",
      { staticClass: "img img--industries" },
      [
        _c("transition", { attrs: { name: "fade" } }, [
          _vm.cardsObject.img
            ? _c("img", { attrs: { src: _vm.cardsObject.img } })
            : _vm._e()
        ])
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass:
          "g-container g-container--fit_auto-sm g-container--fit_md-md g-container--fit_lg-lg g-container--fit_auto_xl g-container--fit_auto_mac",
        staticStyle: { width: "100%", height: "100%" }
      },
      [
        _c(
          "div",
          { staticClass: "g-row g-row--align_center rel z z--5 max_height" },
          [
            _c(
              "div",
              { staticClass: "g-cols g-cols--6 g-cols--n_height g-cell" },
              [
                _c(
                  "div",
                  { staticClass: "nav-items" },
                  _vm._l(_vm.cards, function(item, index) {
                    return _c(
                      "div",
                      {
                        staticClass: "nav-items__title",
                        class: index === 0 ? "active" : "",
                        on: {
                          mouseover: function($event) {
                            return _vm.hoverMouse(item.title)
                          }
                        }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass:
                              "ds-caption ds-caption--c_white ds-caption--size_2md ds-caption--w_r ds-caption--h_130 ds-caption--upp ds-caption--op-5"
                          },
                          [_vm._v(_vm._s(item.title))]
                        )
                      ]
                    )
                  }),
                  0
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "g-cols g-cols--6 g-cell" },
              [
                _c("transition", { attrs: { name: "fade" } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cardsObject.title,
                          expression: "cardsObject.title"
                        }
                      ],
                      staticClass: "right-content"
                    },
                    [
                      _c("div", { staticClass: "el" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "ds-caption ds-caption--c_white ds-caption--size_30xl ds-caption--w_r ds-caption--h_130 ds-caption--upp"
                          },
                          [_vm._v(_vm._s(_vm.cardsObject.title))]
                        )
                      ]),
                      _c("div", { staticClass: "el el--p_t_lg" }, [
                        _c("p", {
                          staticClass:
                            "ds-caption ds-caption--c_white ds-caption--size_md ds-caption--w_r ds-caption--h_200 ds-caption--op-4",
                          domProps: { innerHTML: _vm._s(_vm.cardsObject.text) }
                        })
                      ])
                    ]
                  )
                ])
              ],
              1
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65c07f2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65c07f2c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/app/UiElements/CardsNavigate.vue
// module id = 103
// module chunks = 0